import NavRoutes from "./navRoutes";

const navigationConfig = NavRoutes;

export default navigationConfig;
